import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3b02386"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-info" }
const _hoisted_2 = { class: "device-name" }
const _hoisted_3 = { class: "device-sn-wrap" }
const _hoisted_4 = { class: "device-sn" }
const _hoisted_5 = {
  key: 0,
  class: "service-time"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "增值服务：", -1))
const _hoisted_7 = { class: "span-first" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "质保时间：", -1))
const _hoisted_9 = { class: "span-first" }
const _hoisted_10 = {
  key: 0,
  class: "out-quality-icon"
}

import { withDefaults, computed, ComputedRef } from 'vue'
import { Loading } from 'vant'
import { isValueAddService } from '@/defination/malfunction-repair'
import type { MalfunctionRepairDeviceItem } from '@/types/malfunction-repair'
import { useMalfunctionRepairDeviceTimeFormat } from '@/compositions/malfunction-repair'
import XcareTypeTag from './xcare-type-tag.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'fault-form-device',
  props: {
    deviceInfoList: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { deviceInfoList: MalfunctionRepairDeviceItem[] };

const { serviceTimeFormat } = useMalfunctionRepairDeviceTimeFormat()



const formatDeviceInfoList: ComputedRef<
  (MalfunctionRepairDeviceItem & {
    serviceTimeInfo: {
      start: string
      end: string
    }
    qualityTimeInfo: {
      start: string
      end: string
    }
  })[]
> = computed(() => {
  return props.deviceInfoList.map((item) => {
    const serviceTimeInfo = serviceTimeFormat(item.xcare)
    const qualityTimeInfo = serviceTimeFormat(item.quality)
    const result = {
      ...item,
      serviceTimeInfo,
      qualityTimeInfo,
    }
    return result
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formatDeviceInfoList), (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.guid
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(item.name), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, "SN：" + _toDisplayString(item.serial_number), 1),
          _createVNode(XcareTypeTag, {
            is_quality: item.is_quality,
            xcare_type: item.xcare_type,
            mode: "onlyTags",
            activate_at: item.activate_at,
            xcare: item.xcare,
            quality: item.quality
          }, null, 8, ["is_quality", "xcare_type", "activate_at", "xcare", "quality"])
        ]),
        (_unref(isValueAddService)(item.xcare_type))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString(item.serviceTimeInfo.start), 1),
              _createElementVNode("span", null, _toDisplayString(item.serviceTimeInfo.end), 1)
            ]))
          : _createCommentVNode("", true),
        (item.is_quality !== 0 || item.qualityResetLoading)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["service-time", item.is_quality === 2 ? 'out-quality' : ''])
            }, [
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, _toDisplayString(item.qualityTimeInfo.start), 1),
              _createElementVNode("span", null, _toDisplayString(item.qualityTimeInfo.end), 1),
              (item.is_quality === 2)
                ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                : _createCommentVNode("", true),
              (item.qualityResetLoading)
                ? (_openBlock(), _createBlock(_unref(Loading), {
                    key: 1,
                    color: "#1989fa",
                    size: "12",
                    class: "quality-reset-loading"
                  }))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})